import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import moment from 'moment'
import * as CryptoJS from "crypto-js";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlatformTourModalComponent } from '../platform-tour-modal/platform-tour-modal.component';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private modalService: NgbModal) { }

  /**Credits required by user to enrich any contact details */
  public static ENRICHMENT_CREDITS = {
    CONTACT_PARTNER: 3,
    WEBBTREE_VERIFIED: 20,
    WEBBTREE_INTRO: 100,
    RETRY_CONTACT_REVEAL: 0
  }

  public static USER_TYPE = {
    INTERNAL: 'internal',
    ALL: 'all'
  }


  /** Keys of different modules of History*/
  public static HISTORY_MODULE  ={
    TALENT_INSIGHTS: 'talentinsights',
    COMPANY_INSIGHTS: 'companyinsights',
    PERSON_SEARCH: 'personsearch',
    COMPANY_COMPARISON: 'company_comparison'
  }

  public static chromeid = 'icjcecoafmlannickbnokaahkfomllcf' //rohan chromid

  public static emailPattern = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

  public static PREFERENCE_DATA_DEFAULT = [
    {
      "preference_type": "page-size",
      "listing_type": "person-search",
      "preference_value": "25"
    },
    {
      "preference_type": "page-size",
      "listing_type": "talentpool",
      "preference_value": "10"
    }
  ];

  public static getDates(date: any): any {
    var date1 = new Date(date);
    var date2 = new Date(moment(new Date()).format("YYYY-MM-DD"));

    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays == 1 && moment(date1).format("YYYY-MM-DD") == moment(date2).format("YYYY-MM-DD")) {
      return { text: "Today", type: "day", value: diffDays, urgency: false };
    }
    else if (diffDays < 30) {
      if (diffDays >= 1 && diffDays <= 3)
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: false }
      else
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: true }
    }
    else if (diffDays > 30) {
      var diff = (date2.getTime() - date1.getTime()) / 1000;
      diff /= (60 * 60 * 24 * 7 * 4);
      var months = Math.abs(Math.round(diff));
      return { text: months + " months", type: "month", value: months, urgency: true }
    }
    else {
      return { text: "today", type: "day", value: diffDays, urgency: false };
    }
  }

  public static handleError(operation: String, url: string) {
    return (err: any) => {
      // let errMsg = `error in ${operation}() retrieving ${url}`;
      // console.log(`${errMsg}:`, err)
      // if (err.status === 0 && !url.includes('candidate/bulkgrab'))
      //   window.location.href = '/login'
      // // window.location.href = '/server-error'
      // if (err.status === 401){
      //   localStorage.clear();
      //   sessionStorage.clear();
      //   let visitedURL = window.location.href.replace(window.location.origin,"")
      //   if (visitedURL && visitedURL != "null" && visitedURL != "undefined" && !visitedURL.includes('signup') && !visitedURL.includes('login')){
      //       window.location.href = `/login?redirect=${visitedURL}`
      //   }else{
      //       window.location.href = '/login'
      //   }
      // }
      // if (err.status === 404)
      //   window.location.href = '/login'
      // window.location.href = '/error404'
      return throwError(err);
    }
  }

  public static months = [{ id: '01', name: 'January' }, { id: '02', name: 'February' }, { id: '03', name: 'March' }, { id: '04', name: 'April' }, { id: '05', name: 'May' }, { id: '06', name: 'June' }, { id: '07', name: 'July' }, { id: '08', name: 'August' }, { id: '09', name: 'September' }, { id: '10', name: 'October' }, { id: '11', name: 'November' }, { id: '12', name: 'December' }]

  public static dateFormat(day: any, month: any, year: any) {
    return year + "-" + month + "-" + day;
}
  public static yearList() {
    var currentdate = new Date()
    currentdate.setFullYear(currentdate.getFullYear())
    let year_list = []
    for (let i = 0; i <= 100; i++) {
      year_list.push(currentdate.getFullYear())
      currentdate.setFullYear(currentdate.getFullYear() - 1)
    }
    return year_list;
  }

  public static placeholderlist = [
    { value: "candidate.firstname", type: 'candidate' },
    { value: "candidate.lastname", type: 'candidate' },
    { value: "candidate.currentjobtitle", type: 'candidate' },
    { value: "candidate.currentcompany", type: 'candidate' },
    { value: "candidate.currentlocation", type: 'candidate' },
    { value: "user.firstname", type: 'user' },
    { value: "user.email", type: 'user' },
    { value: "user.lastname", type: 'user' },
  ]


  public static toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  public static SourceList = ['linkedin','monster','naukri','other']

  public static PipelineStatus = ['Hot','Warm','Cold']

  public static decryptData(data: any): any {
    const enc_key = CryptoJS.enc.Base64.parse("#base64Key#");
    const legacy_iv = CryptoJS.enc.Base64.parse("#base64IV#");
    if (typeof data === 'string') {
        data = data.replace(/xMl3Jk/g, '+' ).replace(/Por21Ld/g, '/').replace(/Ml32/g, '=')
    }
    return GlobalService.decryptWithFallback(data, enc_key, legacy_iv) || null;
  }

  public static decryptWithFallback(value: any, key: any, legacyIv: any): string {
    if (typeof value !== 'string' || !value) return '';
    if (value.startsWith('v2')) {
      try {
        const iv = CryptoJS.enc.Hex.parse(value.substr(2, 32));
        const plaintext = CryptoJS.AES.decrypt(value.substring(34), key, { iv }).toString(CryptoJS.enc.Utf8);
        if (plaintext) return plaintext;
      } catch (err) {
        // not a v2 value, try the legacy format
      }
    }
    return CryptoJS.AES.decrypt(value, key, { iv: legacyIv }).toString(CryptoJS.enc.Utf8);
  }

  public static convertToK(number) {
    // console.log(number, 'efefefefef')
    if(number != null){
      const suffixes = ['', 'K', 'M', 'B', 'T']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    }else{
      number = 0;
    }
  }

  public static seniorityLevels = ["owner","cxo","partner","vp","director","senior","manager","entry","training","unpaid",]

  public static buildQueryString(data){
    const queryString = Object.keys(data)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
  .join('&');

  return queryString;

  }
  public static searchType = ["quick-search", "advanced-search", "jd-search", "similar-candidates-linkedin", "similar-candidates-resume"]

  public static getIndustryIcon(name){
    const industriesIcons = {
      "financial services": "sack-dollar",
      "oil & energy": "oil-well",
      "retail": "cart-shopping",
      "utilities": "fire-flame",
      "insurance": "shield-check",
      "information technology and services": "display-code",
      "automotive": "car-wrench",
      "hospital & health care": "suitcase-medical",
      "chemicals": "flask-vial",
      "consumer goods": "bags-shopping",
      "food & beverages": "burger-soda",
      "internet": "globe",
      "construction": "user-helmet-safety",
      "semiconductors": "microchip-ai",
      "mining & metal": "axe",
      "building materials": "trowel-bricks",
      "pharmaceuticals": "capsules",
      "transportation/trucking/railroad": "truck-fast",
      "biotechnology": "dna",
      "electrical/electronic manufacturing": "computer-speaker",
      "packaging and containers": "boxes-packing",
      "real estate": "house-building",
      "telecommunications": "phone-volume",
      "airlines/aviation": "plane"
    }
    if(industriesIcons[name] != null){
      return industriesIcons[name]
    }

    return 'industry'

  }


  public static getPersonSearchActivityText(activity) {
    if(activity.actiontype == 'add_to_pipeline') {
      return `Added to pipeline -  ${activity.name}`
    }
    else if(activity.activitytype == 'Talentpool' && activity.action == 'add'){
      return `Added to talentpool -  ${activity.name}`
    }else if(activity.activitytype == 'Contact Revealed' && activity.action == 'create'){
      if(activity.name.toString().includes('pdl')){
        return 'Contact Revealed - Pdl'
      }else if(activity.name.toString().includes('pipl')){
        return 'Contact Revealed - Pipl'
      }else if(activity.name.toString().includes('pipl')){
        return 'Contact Revealed - Pipl'
      }else if(activity.name.toString().includes('rocket')){
        return 'Contact Revealed - Rocket Reach'
      }else if(activity.name.toString().includes('nymblr')){
        return 'Contact Revealed - Nymblr'
      }else if(activity.name.toString().includes('Webbtree Verified')){
        return 'Contact Requested - Webbtree Verified '
      }else if(activity.name.toString().includes('Webbtree Introduction')){
        return 'Introduction Requested '
      }else if(activity.name.toString().includes('signalhire')){
        return 'Contact Reveal - Signalhire'
      }else if(activity.name.toString().includes('fullenrich')){
        return 'Contact Reveal - FullEnrich'
      }
    }else if(activity.activitytype == 'Contact Revealed' && activity.action == 'added'){
      return `Candidate has been created from Talent Discovery`
    }else if(activity.activitytype == 'Email Campaigns'){
      return `Added to Email Campaign - ${activity.name}`
    }else if(activity.activitytype == 'Profile Viewed'){
      return `Profile Viewed - ${activity.username}`
    } else if (activity.activitytype == 'Unified Activity') {
      return `Added to ${activity.action}`
    } else if (activity.activitytype == 'Screen AI Activity') {
      return `Added to ScreenAI Job - ${activity.name}`
    } else if (activity.activitytype == 'ATS Integration') {
      return `Added to Aegis Mandate`
    }
  }



  public static getProvidername(key){
    if(key != null){
      const keyName = key.toString().toLowerCase();
      if(keyName === 'pipl'){
        return 'Pipl'
      }else if(keyName === 'pdl'){
        return 'People Data Labs'
      }else if(keyName === 'rocketreach'){
        return 'RocketReach'
      }else if(keyName === 'nymblr'){
        return 'Nymblr'
      }else if(keyName == 'webbtree introduction'){
        return 'Webbtree Introduction'
      }else if(keyName == 'webbtree verified'){
        return 'Webbtree Verified'
      } else if(keyName == 'contact partners') {
        return 'Contact Partners';
      }
    }
  }

  public static getUpdateDates(date: any): any {
    var date1 = new Date(date);
    var date2 = new Date(moment(new Date()).format("YYYY-MM-DD"));

    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays == 1 && moment(date1).format("YYYY-MM-DD") == moment(date2).format("YYYY-MM-DD")) {
      return { text: "Today", type: "day", value: diffDays, urgency: false };
    }
    else if (diffDays < 30) {
      if (diffDays >= 1 && diffDays <= 3)
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: false }
      else
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: true }
    }
    else if (diffDays > 30 && diffDays < 365) {
      var enddate = moment();
      var startdate = moment(date)
      var months = enddate.diff(startdate, 'months');

      if(months > 1)
        return { text: months + " mths", type: "month", value: months, urgency: true }
      else
      return { text: months + " mth", type: "month", value: months, urgency: true }
    }
    else if (diffDays > 365) {
      var enddate = moment();
      var startdate = moment(date);
    //  var diff = (date2.getTime() - date1.getTime()) / 1000;
      var yearsDiff = enddate.diff(startdate, 'years');
      var startDatePlusYears = startdate.add(yearsDiff, 'years');
      var monthsDiff = enddate.diff(startDatePlusYears, 'months');
      if(monthsDiff >= 1)
        return { text: yearsDiff + " yrs " + monthsDiff + ' mths', type: "year", value: yearsDiff, urgency: true };
      else
      return { text: yearsDiff + " yrs", type: "year", value: yearsDiff, urgency: true };
    } else {
      return { text: "today", type: "day", value: diffDays, urgency: false };
    }
  }

  public static generateUniqueId(): string {
    return Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);
  }

  public static getAllCandidateActivityText(activity) {
    if(activity.toString().includes('pdl')){
      return 'Contact Revealed - Pdl'
    }else if(activity.toString().includes('pipl')){
      return 'Contact Revealed - Pipl'
    }else if(activity.toString().includes('pipl')){
      return 'Contact Revealed - Pipl'
    }else if(activity.toString().includes('rocket')){
      return 'Contact Revealed - Rocket Reach'
    }else if(activity.toString().includes('numblr')){
      return 'Contact Revealed - Numblr'
    }else if(activity.toString().includes('Webbtree Verified')){
      return 'Contact Requested - Webbtree Verified '
    }else if(activity.toString().includes('Webbtree Introduction')){
      return 'Introduction Requested'
    }
  }


  /**
   * Used to format paragraph
   * Slice it based on view-more or view-less
   * Will trucate the data to paraSize based on viewmode
   * Will break the paragraph in form of bullet points (from mentioned character i.e. `*`)
   * @param formatObj
   *
   * text: Will contain content to be formatted
   * viewmode: will except string, and truncate the data of paraSize (viewmode = 'all', 'less')
   * paraSize: Number of character to show in view-less mode
   * @returns
   * Function will return an object having
   * data -> formatted text
   * isTruncated -> text is truncated or not
   * canOverflow -> text required to trucated or not (i.e. text having length smaller than required paraSize)
   * If paragraph does not require bullet points, function will return array of one ele
   */
  public static getFormattedParagraph(formatObj: { text: string, viewmode: string, paraSize?: number }): { data: string[], isTruncated: boolean, canOverflow: boolean } {
    let { text, viewmode = 'all', paraSize = 300 } = formatObj;
    if (!text) return null;

    const formatItems = (inputText: string): string[] => {
      return inputText.split('*')
        .map(item => item.trim().replace(/^[❖●-]/, '').replace(/^[a-z]\.\s+|^\d+\.\s+/, ''))
        .filter(item => item);
    };

    let items = formatItems(text);
    if (items.join(' ')?.length <= paraSize) {
      return { data: items, isTruncated: false, canOverflow: false };
    } else {
      if (viewmode === 'less') {
        text = text.slice(0, paraSize);
        items = formatItems(text);
        return { data: items, isTruncated: true, canOverflow: true };
      } else {
        return { data: items, isTruncated: false, canOverflow: true };
      }
    }
  }

  /**
   * Function will truncate the given string from middle
   * @param str Given string to truncate
   * @param maxLength maxLength after truncate
   * @returns trucated string
   */
  public static truncateFromMiddle(str, maxLength = 20) {
    if (str.length <= maxLength) {
      return str;
    }

    const halfLength = Math.floor((maxLength - 3) / 2);
    const start = str.substr(0, halfLength);
    const end = str.substr(-halfLength);

    return `${start}...${end}`;
  }


  /**
   * Convert string to titlecase format
   * @param inputString
   */
  public static titleCase(inputString: string) {
    if(typeof inputString !== 'string') return '';
    if ((inputString === null) || (inputString === '')) return '';

    return inputString.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  /**
   * Helper method to check if webbtree chrome extension is installed on client's system
   */
  public static isExtensionInstalled(): boolean {
    const extensionID = localStorage.getItem('extensionID');
    return !!extensionID && (extensionID !== 'null');
  }

  /**
   * Generic helper to trigger tour-modal from anywhere and supply props all at once
   * @param props Modal component props
   */
  public openTourModal(props: { pageToJump?: number } = {}) {
    const tourModalRef = this.modalService.open(PlatformTourModalComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    if(props && Object.keys(props)) {
      Object.keys(props).forEach((key) => {
        tourModalRef.componentInstance[key] = props[key];
      });
    }

    return tourModalRef;
  }

  public static hasHTMLTags(input: string) : boolean {
    if (!input || !input.toString().trim().length) {
      return false;
    }
    input = input.toString().trim().toLowerCase();

    const regex = /<[^>]+>/g;
    return regex.test(input);
  }

  public static hasEncodedHTML(input: string) {
    if (!input || !input.toString().trim().length) {
      return false;
    }
    input = input.toString().trim().toLowerCase();

    const encodedTagRegex = /&lt;[^&]+&gt;/g;
    return encodedTagRegex.test(input);
  }

  /**
   * Helper method to convert number to years and months format
   * @param input
   */
  public static convertNumberToYearsAndMonths(input: number | string){
    let years = null;
    try {
      years = typeof input !== 'number' ? parseFloat(input) : input;
    } catch (err) {
      return { years: '0', months: '0' };
    }

    if (years == null || isNaN(years)) {
      return { years: '0', months: '0' };
    }

    const totalYears = Math.floor(years);
    const totalMonths = Math.round((years - totalYears) * 12);

    return { years: totalYears, months: totalMonths };
  }

  public static urlEncode(data) {
    return Object.keys(data).map(key => key + '=' + data[key]).join('&');
  }


  public static hash(data: string) {
    const hash = CryptoJS.HmacSHA1(data, CryptoJS.enc.Base64.parse("#base64Key#"));
    return hash.toString(CryptoJS.enc.Hex);
  }



  /**
   * Helper method to format number to Indian format
   * @param number
   */
  public static formatNumberToIndianFormat(number: string | number) {
    number = Number(number);
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  /**
   * Sanitize filename by replacing special characters with underscore (_)
   * @param file File to be sanitized
   * @returns Sanitized File
   * @throws Error if file extension is not allowed or file size exceeds limit
   */
  public static validateAndSanitizeFile(file: File, options?: SafeFileOptions): File {
    if (!file) {
      return file;
    }
    const { allowSpecialCharacters = false, allowedExtensions = [], size = Infinity, replaceSpecialCharactersWith = ' ' } = options || {};
    const oldFileName = file.name;
    const fileExtension = oldFileName.split('.').pop().toLowerCase();

    if (allowedExtensions.length > 0 && !allowedExtensions.includes(fileExtension)) {
      throw new Error(`Invalid file format. Allowed formats: ${allowedExtensions.join(', ')}`);
    }

    if (size && file.size > size) {
      throw new Error(`File size exceeds the limit of ${size / (1024 * 1024)} MB.`);
    }
    const oldFileNameWithoutExt = oldFileName.substring(0, oldFileName.lastIndexOf('.'));
    let sanitizedFilename = oldFileNameWithoutExt;
    if (allowSpecialCharacters) {
      sanitizedFilename = oldFileNameWithoutExt + '.' + fileExtension;
      return new File([file], sanitizedFilename, { type: file.type });
    } else {
      const filenameRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/g;
      sanitizedFilename = oldFileNameWithoutExt.replace(filenameRegex, replaceSpecialCharactersWith) ;
      const regex = new RegExp(`${replaceSpecialCharactersWith}+`, 'g');
      sanitizedFilename = sanitizedFilename.replace(regex, replaceSpecialCharactersWith).trim() + '.' + fileExtension; // Replace multiple spaces with single space and trim
    }
    return new File([file], sanitizedFilename, { type: file.type });
  }

  public static positionHierarchyData = [
    "senior leadership",
    "mid-level leadership",
    "entry-level & training",
    "high-level executives",
    "top-level executives"
]
}


export interface SafeFileOptions {
  /**
   * Whether to allow special characters in the filename or not
   */
  allowSpecialCharacters?: boolean;
  replaceSpecialCharactersWith?: string;
  /**
   * Array of allowed file extensions (without dot)
   */
  allowedExtensions?: string[];
  /**
   * Maximum allowed size of the file in bytes
   */
  size?: number; // in bytes
}
